// MedNudge - Firebase Web Push initialization
// Place this file at: webapp/src/firebase-init.js

import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';

// These values come from Firebase Console → Project Settings → General → Your apps
// Safe to include in frontend code
const firebaseConfig = {
  apiKey: "AIzaSyBWXTJ8I9DqSoHaYL4AoJw-vMq-PTgegmg",
  authDomain: "mednudge-1816e.firebaseapp.com",
  projectId: "mednudge-1816e",
  storageBucket: "mednudge-1816e.firebasestorage.app",
  messagingSenderId: "800783424330",
  appId: "1:800783424330:web:eb15feae739dc548e53fb3"
};

const VAPID_KEY = 'BJomkMOi2sPL7pNLuFkGyYVxeoznBU7iK6adhBYeSa8cXEW-v0zt-hBa2K89UWdllHDFt-GWBRmlO6PlmEj6udM';

let app;
let messaging;
let auth;

function getFirebaseApp() {
  if (!app) app = initializeApp(firebaseConfig);
  return app;
}

// Firebase Authentication (email-link sign-in) — safe to call any time, no
// browser-support check needed unlike messaging.
export function getFirebaseAuth() {
  if (!auth) {
    auth = getAuth(getFirebaseApp());
    // iOS home-screen ("Add to Home Screen") web apps run in a standalone
    // WKWebView that has a long-standing WebKit bug wiping IndexedDB between
    // launches — Firebase Auth's default persistence uses IndexedDB, so every
    // relaunch from the home screen icon looked like a fresh, logged-out
    // session. localStorage survives there, so pin it explicitly.
    setPersistence(auth, browserLocalPersistence).catch(() => {});
    // Without this, storage is "best-effort" and the OS can silently evict it
    // under storage pressure with no warning — ask to be exempted from that.
    if (navigator.storage && navigator.storage.persist) {
      navigator.storage.persist().catch(() => {});
    }
  }
  return auth;
}

export async function initFirebase() {
  if (messaging) return;
  const supported = await isSupported();
  if (!supported) {
    console.log('Firebase Messaging not supported in this browser');
    return;
  }
  messaging = getMessaging(getFirebaseApp());
}

// Request permission and get FCM token
export async function requestNotificationPermission(userId) {
  if (!('Notification' in window)) {
    if (!messaging) return null;
    console.log('This browser does not support notifications');
    return null;
  }

  const permission = await Notification.requestPermission();
  if (permission !== 'granted') {
    console.log('Notification permission denied');
    return null;
  }

  try {
    // Register service worker first
    const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');

    const token = await getToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: registration
    });

    if (token) {
      const { api } = await import('./api');
      await api.updateUser(userId, { fcm_token: token });
      console.log('FCM token registered with server');
    }
    return token;
  } catch (err) {
    console.error('Error getting FCM token:', err);
    return null;
  }
}

// Handle foreground notifications (app is open)
export function setupForegroundNotifications() {
  if (!messaging) return;
  onMessage(messaging, (payload) => {
    const { title, body } = payload.notification || {};
    // Show as browser notification even when app is open
    if (Notification.permission === 'granted') {
      new Notification(title || 'MedNudge', {
        body: body || '',
        icon: '/icon-192.png'
      });
    }
  });
}
